<div class="big-box">

  <div class="ui-g ui-fluid">
    <div class="col-2 ui-g-2">
      <h1><a class="tab-link" routerLink="/servicedesk">Accounts</a></h1>
    </div>
    <div class="col-2 ui-g-2">
      <h1>
        <a class="tab-link tab-active"
           routerLink="{{accountId ? '/usermanagement/'+accountId:'/usermanagement'}}">Users</a>
      </h1>
    </div>
  </div>

  <div class="center">
    <iui-messages mode="alert" class="ms-auto me-auto"></iui-messages>
  </div>

  <div class="col ui-g result-bar">
    <div class="ui-g-4">
      <span style="margin-top: 8px; font-size: 14px;">
            (Displaying {{ptable.totalRecords}} of {{totalItems}})
      </span>
    </div>
    <div class="ui-g-8">
      <button id="btn-add-users" [hidden]="true" disabled style="margin-left: 2em;" class="btn btn-disabled pull-right width-150px"
              >Add Users
      </button>
    </div>
  </div>

  <div style="margin-bottom:5%">
    <p-table
      #ptable
      id="users-table"
      [columns]="userHeaders"
      [styleClass]="'btable'"
      [value]="users"
      [sortField]="'username'"
      [sortOrder]="1"
      (onFilter)="onFilter($event)"
      (sortFunction)="customSort($event)" 
      [customSort]="true"
      [paginator]="true"
      [rows]="1000"
    >

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th [style.width.%]="col.width" *ngFor="let col of columns" [pSortableColumn]="col.field" (click)="sortBy(col)">
            <span class="user-tbl-header-size">{{col.header}}</span>
            <p-sortIcon #psortIcon [field]="col.field" ></p-sortIcon>
          </th>
        </tr>
        <tr>
          <th *ngFor="let col of columns" [ngSwitch]="col.field">
            <!-- filter: 'startsWith' -->
            <input [(ngModel)]="filter[col.field]" *ngSwitchDefault class="form-control filter-size" type="text"
                  (input)="ptable.filter($event.target.value, col.field, col.filterMatchMode)">
           
            <input [(ngModel)]="filter[col.field]" *ngSwitchCase="'userRoleList.roleid'" class="form-control filter-size" type="text"
                  (input)="ptable.filter($event.target.value, 'userRoleList[0].rolename', col.filterMatchMode)">
            <!-- filter: 'contains' -->
            <input [(ngModel)]="filter.email" *ngSwitchCase="'email'" class="form-control filter-size" type="text"
                  (input)="ptable.filter($event.target.value, col.field, 'contains')">
                  <span disabled *ngSwitchCase="'createdtime'"></span>
                  <span disabled *ngSwitchCase="'lastLoginDateTime'"></span>
                  <span disabled *ngSwitchCase="'userRegistrationTokenExpTime'"></span>

                

  
                  
            <!-- filter: 'roles'
            <p-multiSelect [(ngModel)]="filter.role" *ngSwitchCase="'role'" class="p-formcontrol" [options]="roleNames" placeholder="All Types"
                          (onChange)="ptable.filter($event.value, col.field, 'contains')"></p-multiSelect> -->

            <!-- filter: remove some filters -->
            <span disabled *ngSwitchCase="'disabled'"></span>
            <span disabled *ngSwitchCase="'send'"></span>
            <span disabled *ngSwitchCase="'locked'"></span>

          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" class="usage-tbl-body" let-user>
        <tr>
          <td>{{user.username}}</td>
          <td>{{user.accountId}}</td>
          <td>{{user.firstname}}</td>
          <td>{{user.lastname}}</td>
          <td>{{user.email}}</td>
          <td>{{user.phone}}</td>
          <td>{{user.userRoleNames}}</td>
          <td>{{user.createdtime | date:'yyyy-MM-dd h:mm a'}}</td>
          <td>{{user.lastLoginDateTime | date:'yyyy-MM-dd h:mm a'}}</td>
          <!--<td>{{user.userRegistrationTokenExpTime | date:'yyyy-MM-dd h:mm a'}}</td>-->
          <td>
            <span *ngIf="user.userRegistrationTokenExpTime && !user.username">
              {{user.userRegistrationTokenExpTime | date:'yyyy-MM-dd h:mm a'}}
              </span>
            <span *ngIf="user.passwordExpirationTime && user.username">
              {{user.passwordExpirationTime | date:'yyyy-MM-dd h:mm a'}}
              </span>
            
          </td>
          <td>
            <p-checkbox *ngIf="user.username || user.password" [disabled]='user.self || !user.username' (click)="toggleAccess(user)" [(ngModel)]="user.allowAccess"
                        name="allowAccess{{user.username}}" binary="true"></p-checkbox>
          </td>
          <td>
            <span *ngIf="user.forgotPasswordTokenExpirationTime && user.username && !user.disabled">
                Expires {{user.forgotPasswordTokenExpirationTime | timefromnow}}
                <br>
                <a class="link action text-xs" i18n href="javascript:void(0);" (click)="initPasswordReset(user)">Resend Reset Password</a>
              </span>
            <span *ngIf="!user.forgotPasswordTokenExpirationTime && user.username && !user.disabled">
                <a class="link action text-xs" i18n href="javascript:void(0);" (click)="initPasswordReset(user)">Reset Password</a>
              </span>
            <span *ngIf="!user.username && !user.disabled">
                <a class="link action text-xs" i18n href="javascript:void(0);" (click)="resendWelcome(user)">Resend Welcome Email</a>
              </span>
            <span *ngIf="user.disabled">n/a</span>
          </td>
          <td>
            <a class="link action text-xs" *ngIf="user.locked && !user.disabled" href="javascript:void(0);"
              (click)="unlock(user)">Unlock</a>
            <span *ngIf="!user.locked || user.disabled">n/a</span>
          </td>
        </tr>
      </ng-template>

    </p-table>
    <!--<p-paginator *ngIf="totalItems > users?.length" [rows]="paging.limit" [totalRecords]="totalItems" (onPageChange)="paginate($event)"></p-paginator>-->
  </div>
</div>
